import GamePortrait from "./Game.portrait";
export default GamePortrait;
